// extracted by mini-css-extract-plugin
export default {"image":"hZ-z","loaded":"iZ-z"};